module.exports = __webpack_public_path__ + "static/acumulation-step1-UY-f8a572979e4b957dda6766ca457be7b9.png";